/* eslint-disable import/prefer-default-export */

/**
 * @typedef {Object} UpcAvailability
 * @property {string} color
 * @property {string} size
 * @property {string} type
 * @property {boolean} available
 * @property {number} upcId
 */

/**
 *
 * @param {UpcAvailability} upc
 * @param {'color' | 'size' | 'type'} traitName
 * @param {traitId} traitId
 * @returns {boolean}
 */
const checkTrait = (upc, traitName, traitId = null) => (traitId === null) || (upc[traitName] === traitId.toString());

/**
 *
 * @param {UpcAvailability[]} availability
 * @param {{sizeId?: traitId, colorId?: traitId, typeId?: traitId}} ids
 * @returns {boolean}
 */
export function isAnyUpcAvailable(availability, { sizeId, colorId, typeId }) {
  return availability.filter((upc) => checkTrait(upc, 'size', sizeId) && checkTrait(upc, 'color', colorId) && checkTrait(upc, 'type', typeId) && upc.available).length > 0;
}
